import {
  isTransferActivity,
  TRANSPORT_CATEGORY_SLUG,
  transportHubParts,
} from "../../activities/lib/activity-href";

/**
 * Transfer routes have no pages of their own (owner decision): every one is
 * booked on `/<lang>/transport`. These decide, for a route loader that has
 * already looked the activity (or the category) up, whether the request
 * belongs on the hub instead. They return the options for TanStack's
 * `redirect(...)`, always a 301 so search engines move the old URL's signal
 * to the hub, or null when the page is not a transfer's and stays as it is.
 */

type ActivityLike = {
  slug?: string | null;
  template?: string | null;
  categorySlug?: string | null;
  category?: { slug?: string | null } | null;
} | null | undefined;

/** A transfer route's page (canonical, short or legacy) → the hub with the route preselected. */
export function transferHubRedirect(activity: ActivityLike, lang: string) {
  if (!activity?.slug || !isTransferActivity(activity)) return null;
  return {
    ...transportHubParts(lang, activity.slug),
    replace: true,
    statusCode: 301,
  } as const;
}

/** `/<lang>/category/transport` (and its city variants) → the hub. */
export function transportCategoryRedirect(category: string | null | undefined, lang: string) {
  if ((category ?? "").trim().toLowerCase() !== TRANSPORT_CATEGORY_SLUG) return null;
  return {
    to: "/$lang/transport",
    params: { lang },
    replace: true,
    statusCode: 301,
  } as const;
}
